import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import httpv2 from 'apis/httpv2';
import { ChartOfAccountsDtoV2, QueryConfig } from 'types';

interface MyChartsSearchParamsType {
  code?: string;
  id?: number;
}

export const getMyCharts = (searchParams?: MyChartsSearchParamsType) => {
  return httpv2.get<ChartOfAccountsDtoV2[]>(`charts-of-accounts/me`, { params: searchParams });
};

export const getMyChartsQueryOptions = (searchParams?: MyChartsSearchParamsType) => {
  return queryOptions({
    queryKey: ['charts-of-accounts', 'me', { searchParams }],
    queryFn: () => getMyCharts(searchParams),
  });
};

interface UseMyChartsOptions {
  queryConfig?: QueryConfig<typeof getMyChartsQueryOptions>;
  searchParams?: MyChartsSearchParamsType;
}

export const useSuspenseMyCharts = ({ queryConfig, searchParams }: UseMyChartsOptions = {}) => {
  return useSuspenseQuery({
    ...getMyChartsQueryOptions(searchParams),
    ...queryConfig,
  });
};
export const useMyCharts = ({ queryConfig, searchParams }: UseMyChartsOptions = {}) => {
  return useQuery({
    ...getMyChartsQueryOptions(searchParams),
    ...queryConfig,
  });
};
